<template>
  <a :href="item.url" class="c-card">
    <div v-if="item.image && item.image.url" class="c-card__image-frame">
      <img class="c-card__image" :src="item.image.url" :alt="item.image.alt" :width="item.image.width"
        :height="item.image.height" />
    </div>
    <div class="c-card__details">
      <div class="c-card__title">
        <h3 class="c-card__heading u-text-color-brand-two">{{ item.heading }}</h3>
        <svg class="c-card__button-icon" aria-hidden="true" focusable="false">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right--round"></use>
        </svg>
      </div>
      <p class="c-card__description">{{ item.description }}</p>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/card-list/Card.vue